var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_box_FILL1_wght400_GRAD0_opsz48 (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7404 29.9106L31.268 16.3362L29.2553 14.3234L17.7404 25.8851L12.1702 20.3149L10.1574 22.3277L17.7404 29.9106ZM6.55314 39.3191C5.8042 39.3191 5.14888 39.0383 4.58718 38.4766C4.02548 37.9149 3.74463 37.2596 3.74463 36.5106V8.42553C3.74463 7.67659 4.02548 7.02127 4.58718 6.45957C5.14888 5.89787 5.8042 5.61702 6.55314 5.61702H34.6382C35.3872 5.61702 36.0425 5.89787 36.6042 6.45957C37.1659 7.02127 37.4468 7.67659 37.4468 8.42553V36.5106C37.4468 37.2596 37.1659 37.9149 36.6042 38.4766C36.0425 39.0383 35.3872 39.3191 34.6382 39.3191H6.55314Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.f0fad050a70796de79a723a8c83d86d4.svg";
export { ForwardRef as ReactComponent };